import { useEffect, useRef, useState } from "react";
import { Axios } from "../../../Api/axios";
import { SUBJECT, ADMIN_ALL_CLASSES } from "../../../Api/Api";
import LoadingSubmit from "../../../Components/Loading/Loading";
import { useNavigate } from "react-router-dom";
import DashDialog from "../../../Components/Dashboard/DashDialog";
import DashSelect from "../../../Components/Dashboard/DashSelect";
import "./add-material.css";

export default function AddMaterial() {
  const [teacherName,   setTeacherName]   = useState("");
  const [teacherPhone,  setTeacherPhone]  = useState("");
  const [teacherPhoto,  setTeacherPhoto]  = useState(null);
  const [photoPreview,  setPhotoPreview]  = useState(null);
  const [name,          setName]          = useState("");
  const [loading,       setLoading]       = useState(false);
  const [classLoading,  setClassLoading]  = useState(true);
  const [error,         setError]         = useState(null);
  const [phoneError,    setPhoneError]    = useState("");
  const [grades,        setGrades]        = useState([]);
  const [selectedGradeId, setSelectedGradeId] = useState("");

  const nameRef  = useRef(null);
  const fileRef  = useRef(null);
  const nav      = useNavigate();

  useEffect(() => { nameRef.current?.focus(); }, []);

  useEffect(() => {
    Axios.get(ADMIN_ALL_CLASSES)
      .then((res) => setGrades(res.data.classes || []))
      .catch(() => setError("تعذر تحميل قائمة الصفوف"))
      .finally(() => setClassLoading(false));
  }, []);

  function validatePhone(value) {
    if (!value.trim()) return "";
    const syrian = /^(09\d{8}|\+9639\d{8})$/;
    return syrian.test(value.trim()) ? "" : "الرقم يجب أن يكون سورياً (يبدأ بـ 09 أو +963)";
  }

  function handlePhotoChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setTeacherPhoto(file);
    setPhotoPreview(URL.createObjectURL(file));
  }

  function removePhoto() {
    setTeacherPhoto(null);
    setPhotoPreview(null);
    if (fileRef.current) fileRef.current.value = "";
  }

  async function handleSubmit() {
    if (!name || !teacherName || !selectedGradeId) return;
    const phoneErr = validatePhone(teacherPhone);
    if (phoneErr) { setPhoneError(phoneErr); return; }
    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("teacher_name", teacherName);
    formData.append("teacher_phone", teacherPhone);
    if (teacherPhoto) formData.append("teacher_photo", teacherPhoto);
    formData.append("class_id", selectedGradeId);
    try {
      await Axios.post(SUBJECT, formData);
      nav("/dashboard/categories");
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  const isValid = name.length >= 1 && teacherName.length >= 2 && !!selectedGradeId && !phoneError;

  return (
    <>
      {loading && <LoadingSubmit />}
      <DashDialog
        title="إضافة مادة جديدة"
        onSubmit={handleSubmit}
        submitDisabled={!isValid || loading}
        submitLabel={loading ? "جاري الحفظ..." : "حفظ المادة"}
      >
        {/* Class */}
        <div className="am-field">
          <label className="am-label">
            <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24" className="am-label-icon">
              <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
            </svg>
            الصف
          </label>
          <DashSelect
            value={selectedGradeId}
            onChange={setSelectedGradeId}
            options={[
              { value: "", label: classLoading ? "جاري التحميل..." : error ? "حدث خطأ" : "اختر الصف" },
              ...grades.map((g) => ({ value: g.id, label: g.name })),
            ]}
            icon={
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
              </svg>
            }
          />
        </div>

        {/* Subject name */}
        <div className="am-field">
          <label className="am-label" htmlFor="am-subject">
            <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24" className="am-label-icon">
              <path d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-2 14H8v-2h8v2zm0-4H8v-2h8v2zm0-4H8V6h8v2z"/>
            </svg>
            المادة
          </label>
          <div className="am-input-wrap">
            <input
              id="am-subject"
              ref={nameRef}
              className="am-input"
              type="text"
              placeholder="اسم المادة..."
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
        </div>

        {/* Teacher name */}
        <div className="am-field">
          <label className="am-label" htmlFor="am-teacher">
            <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24" className="am-label-icon">
              <path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v2h20v-2c0-3.3-6.7-5-10-5z"/>
            </svg>
            اسم المدرس
          </label>
          <div className="am-input-wrap">
            <input
              id="am-teacher"
              className="am-input"
              type="text"
              placeholder="اسم المدرس..."
              value={teacherName}
              onChange={(e) => setTeacherName(e.target.value)}
              required
            />
          </div>
        </div>

        {/* Teacher phone */}
        <div className="am-field">
          <label className="am-label" htmlFor="am-phone">
            <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24" className="am-label-icon">
              <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/>
            </svg>
            رقم المدرس
          </label>
          <div className={`am-input-wrap${phoneError ? " am-input-error" : ""}`}>
            <input
              id="am-phone"
              className="am-input"
              type="text"
              placeholder="مثال: 0933123456 أو +963933123456"
              value={teacherPhone}
              onChange={(e) => { setTeacherPhone(e.target.value); setPhoneError(""); }}
              onBlur={() => setPhoneError(validatePhone(teacherPhone))}
            />
          </div>
          {phoneError && <p className="am-field-err">{phoneError}</p>}
        </div>

        {/* Teacher photo */}
        <div className="am-field">
          <label className="am-label">
            <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24" className="am-label-icon">
              <path d="M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4z"/>
              <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
            </svg>
            صورة المدرس
            <span className="am-optional">(اختياري)</span>
          </label>
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handlePhotoChange}
          />
          {photoPreview ? (
            <div className="am-photo-preview">
              <img src={photoPreview} alt="صورة المدرس" className="am-photo-img" />
              <div className="am-photo-info">
                <span className="am-photo-name">{teacherPhoto?.name}</span>
                <span className="am-photo-size">
                  {teacherPhoto && teacherPhoto.size < 900 * 1024
                    ? (teacherPhoto.size / 1024).toFixed(0) + " KB"
                    : teacherPhoto && (teacherPhoto.size / (1024 * 1024)).toFixed(1) + " MB"}
                </span>
                <div className="am-photo-actions">
                  <button type="button" className="am-photo-change" onClick={() => fileRef.current?.click()}>
                    تغيير
                  </button>
                  <button type="button" className="am-photo-remove" onClick={removePhoto}>
                    حذف
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <button type="button" className="am-upload-zone" onClick={() => fileRef.current?.click()}>
              <div className="am-upload-icon">
                <svg width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4z"/>
                  <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
                </svg>
              </div>
              <p className="am-upload-hint">اضغط لرفع صورة المدرس</p>
              <p className="am-upload-sub">PNG، JPG، WEBP — حتى 5 ميغابايت</p>
            </button>
          )}
        </div>
      </DashDialog>
    </>
  );
}
